import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  buttonsExpanded: false,
  contentWidth: null,
  defaultContentWidth: (220 + 22 + 1000 + 40),
  buttonWrapperWidth: 282,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
